<template>
  <div class="top-right-info">
    <h4>{{$t('medium_grant_ev.general__you_are_evaluating')}} <strong>{{application.reference}}</strong></h4>
  </div>
</template>
<script>
  import {EvaluationForm} from "@/services";

  export default {
    data() {
      return EvaluationForm
    }
  }
</script>
<style lang="scss" scoped>
  .top-right-info {
    position: absolute;
    right: 2rem;
  }
</style>